import { PolicyCollectionTable } from "./policy-collection-table";
import { PolicyDirectoryRow } from "./policy-directory-row";
import {
  AsyncRegion,
  EmptyState,
  SkeletonText,
  TableCell,
  TableRow,
} from "@softmax/design-system";
import type { PoliciesDirectoryState } from "./policy-directory-records";

export function PolicyCollection({
  state,
  layout,
}: {
  readonly state: PoliciesDirectoryState;
  readonly layout: "page" | "workspace";
}) {
  return (
    <AsyncRegion
      pending={state.status === "loading"}
      label="Loading policies"
      placeholder={
        <PolicyCollectionTable layout={layout}>
          {Array.from({ length: 10 }, (_, index) => (
            <TableRow key={index}>
              <TableCell>
                <SkeletonText width="80%" />
              </TableCell>
              <TableCell>
                <SkeletonText width="65%" />
              </TableCell>
              <TableCell align="end">
                <SkeletonText width={32} />
              </TableCell>
              <TableCell>
                <SkeletonText width={88} />
              </TableCell>
            </TableRow>
          ))}
        </PolicyCollectionTable>
      }
    >
      {state.status === "ready" &&
        (state.rows.length === 0 ? (
          <EmptyState
            size={layout === "workspace" ? "compact" : "default"}
            title={state.search ? "No matching policies" : "No policies yet"}
          >
            {state.search
              ? "Try another policy name."
              : "Uploaded policies will appear here."}
          </EmptyState>
        ) : (
          <PolicyCollectionTable layout={layout}>
            {state.rows.map((row) => (
              <PolicyDirectoryRow key={row.id} row={row} layout={layout} />
            ))}
          </PolicyCollectionTable>
        ))}
    </AsyncRegion>
  );
}
